import { SAMPLE_DATA } from '../../lib/sample';
import { useActivity } from '../activity/useActivity';
import { useApprovals } from '../approvals/useApprovals';
import { useClaudeTasks } from '../claudeTasks/useClaudeTasks';
import { useFinance } from '../finance/useFinance';
import { useReminders } from '../reminders/useReminders';
import { useShipments } from '../shipments/useShipments';
import { buildNotifications } from './build';

/** Every notification, gathered from what the app already knows */
export function useNotifications() {
  const ships = useShipments().items;
  return buildNotifications({
    reminders: useReminders().items,
    fins: useFinance(),
    approvals: useApprovals().items,
    log: useActivity().items,
    tasks: useClaudeTasks().items,
    // the sample log already holds its own made-up shipment alerts
    ships: SAMPLE_DATA ? [] : ships,
  });
}
